<template>
  <header class="navbar">
    <div class="navbar-section">
      <div class="navbar-brand"><img src="../../assets/img/tt_logo_tm_black_rgb.png"></div>
      <figcaption class="navbar-title">Service Area Mapping</figcaption>
    </div>
    <div class="navbar-section">
      <p>{{ distributorName }}</p>
      <nav
        v-if="$route.name === 'Home' || 'Distributor'"
        class="navbar-nav">
        <IconButton
          class="btn-primary"
          @click="togglePanel">
          <i class="icon icon-menu"/>
        </IconButton>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { mutationTypes } from '@/store/types';
import IconButton from '@/components/ui/IconButton';

export default {
  name: 'NavBar',
  components: {
    IconButton,
  },
  computed: {
    ...mapState('distributor', [
      'dealers',
    ]),
    ...mapGetters('distributor', {
      distributorName: 'name',
    }),
  },
  methods: {
    togglePanel() {
      this.$store.commit(mutationTypes.global.setPanelManuallyToggled);
      this.$store.commit(mutationTypes.global.togglePanelOpen);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~spectre.css/src/navbar';

.navbar {
  box-shadow: 2px 0 10px 0 rgba($color-black, .3);
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
  z-index: 1;
}

.navbar-brand {
  padding: 7px 0;

  img {
    height: auto;
    max-width: 150px;
  }
}

.navbar-title {
  font-weight: bold;
  margin-left: 2em;
  padding-top: .35em;
}
</style>



// WEBPACK FOOTER //
// src/components/page/NavBar.vue